
export default {
  name: "DepartureCities",

  data: function () {
    return {
      search: ""
    }
  },

  props: {
    cities: {
      type: Array,
      default: () => {
        return []
      }
    },
    isLoad: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    list: function () {
      if (!!this.search) {
        const search = this.search.toLowerCase();
        return (this.cities || [])
            .filter((t) => {
              const cityName = (t.city_name || "").toLowerCase();
              return Boolean(cityName.indexOf(search) > -1)
            })
      }
      return this.cities || []
    },
    defaultSubdomain: function () {
      return this.$store.state?.appState?.vars?.['Дефолтный SLUG города'] || ""
    }
  },

  components: {
    FormAddCityList: () => import("~/components/routes/FormAddCityList")
  }
}
